import { Component, Input } from '@angular/core';

@Component({
    selector: 'image-loader',
    template: require('./image-loader.component.html')
})
export class ImageLoaderComponent {

	@Input("img-src") imgSrc;
	@Input("img-class") imgClass;
	@Input("img-style") imgStyle;

	@Input() message : string ="Generating thumbnail";

	loaded: boolean;
	error: boolean;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/image-loader.component.ts